import { EnglishHeadline, GermanHeadline, Image } from "@components";
import React from 'react';
export default {
  EnglishHeadline,
  GermanHeadline,
  Image,
  React
};